/**
 * Enumerador para tipos de avaliação
 * Mantém compatibilidade com o backend
 */
export enum EvaluationType {
  REACTION = 'REACTION',
  KNOWLEDGE = 'KNOWLEDGE',
  IMPACT = 'IMPACT',
  STUDENT_IMPACT = 'STUDENT_IMPACT'
}

/**
 * Status de matrícula/conclusão
 */
export enum EnrollmentStatus {
  NOT_ATTEMPTED = 'NOT_ATTEMPTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  PASSED = 'PASSED',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED'
}

/**
 * Status de avaliação de impacto
 */
export enum ImpactEvaluationStatus {
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  EXPIRED = 'EXPIRED'
}
